import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnOffender extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public mugshotFrontUrl: string;

  @Expose()
  public mugshotSideUrl: string;

  @Expose()
  public mugshotFrontBase64: string;

  @Expose()
  public mugshotSideBase64: string;

  @Expose()
  public releaseDate: string;

  @Expose()
  public birthDate: string;

  @Expose()
  public lat: number;

  @Expose()
  public lon: number;

  @Expose()
  public firstName: string;

  @Expose()
  public lastName: string;

  @Expose()
  public race: string;

  @Expose()
  public sex: string;

  @Expose()
  public ethnicity: string;

  @Expose()
  public skinTone: string;

  @Expose()
  public hairColor: string;

  @Expose()
  public eyeColor: string;

  @Expose()
  public height: string;

  @Expose()
  public weight: string;

  @Expose()
  public build: string;

  @Expose()
  public hasRichOffenseData: string;

  @Expose()
  public licensePlate: string;

  @Expose()
  public offenderId: string;

  @Expose()
  public supervisingAgent: string;

  @Expose()
  public supervisionComments: string;

  @Expose()
  public offenseStatutes: string;

  @Expose()
  public offenseInformation: string;

  @Expose()
  public addressCounty: string;

  @Expose()
  public registeredAddress: string;

  @Expose()
  public city: string;

  @Expose()
  public state: string;

  @Expose()
  public zip: string;

  @Expose()
  @ExposeRawData()
  public aka: any;

  @Expose()
  public lawEnforcementAgency: string;

  @Expose()
  @ExposeRawData()
  public geometry: Point;

  get coords(): { lng: number; lat: number } {
    if (!this.geometry) {
      return;
    }

    return {
      lng: this.geometry.coordinates[0],
      lat: this.geometry.coordinates[1],
    };
  }

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
